// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import ActionBar from '../../layout/ActionBar';
import CompanyTypeForm from './components/CompanyTypeForm';
import DeleteCompanyType from './slideout/DeleteCompanyType';
import Loading from '../../common/Loading';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import ResponsiveActionBarButtons from '../../common/ResponsiveActionBarButtons';
import Button from '../../common/Button';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { getCompanyTypeById } from '../../../api/companyTypeApi';
import { saveCompanyType } from '../../../reducers/companyTypeReducer';
import { useAppDispatch } from '../../../hooks';

function CompanyType() {
  const { id } = useParams();
  const [pageTitle, setPageTitle] = usePageTitle(['Company types', 'Settings']);

  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const onSubmit = (data) => {
    dispatch(saveCompanyType({ ...companyType, ...data }))
      .unwrap()
      .then(() => {
        setCompanyType({ ...companyType, ...data });
        toast.success(t('Company type saved'));
      })
      .catch((ex) => {
        console.error(ex);
        toast.error(t('Failed to save company type'));
      });
  };

  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);
  const handleDelete = (e) => {
    e.cancelBubble = true;
    setDeleteSlideoutOpen(true);
    return false;
  };

  const [companyType, setCompanyType] = useState({});

  useEffect(() => {
    if (id) {
      getCompanyTypeById(id)
        .then((d) => {
          setCompanyType(d);
          setPageTitle([d.name, 'Company types']);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/company-types/');
          toast.error(t('Company type not found'));
        });
    }
  }, [id, t, setPageTitle, navigate]);

  return companyType ? (
    <>
      <ActionBar
        breadcrumb={[
          { link: '/settings/company-types', label: t('Company types') },
          { label: companyType.name },
        ]}
      >
        <div className="d-flex">
          <ResponsiveActionBarButtons
            buttons={[
              id && (
                <Button
                  className="btn btn-danger ms-2 d-none d-md-inline-flex"
                  onClick={handleDelete}
                  text={t('Delete')}
                />
              ),
              <Button
                key="save"
                className="btn btn-primary ms-2"
                onClick={handleSubmit(onSubmit)}
                text={t('Save')}
              />,
            ]}
          />
        </div>
      </ActionBar>
      <CompanyTypeForm
        companyType={companyType}
        register={register}
        errors={errors}
        control={control}
      />

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeleteCompanyType
          id={id}
          done={(d) => {
            setDeleteSlideoutOpen(false);
            navigate('/settings/company-types/');
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading></Loading>
  );
}

export default CompanyType;
